// Sidebar.js
import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaHome,
  FaUserTie,
  FaStore,
  FaBoxes,
  FaTabletAlt,
  FaTags,
  FaChartLine,
  FaClipboardList,
  FaCog,
  FaHeadset,
} from "react-icons/fa";

import "./SideBar.css";
// import logo from "/mnt/data/ae3d3ad3-1e5f-4586-bd86-21094385e99c.png";

export default function Sidebar() {
  const menus = [
    { name: "Dashboard", path: "/dashboard", icon: <FaHome /> },
    { name: "Owners", path: "/list-owner", icon: <FaUserTie /> },
    { name: "Vendors", path: "/vendors", icon: <FaStore /> },
    { name: "Managers", path: "/managers", icon: <FaBoxes /> },
    { name: "Devices", path: "/devices", icon: <FaTabletAlt /> },
    { name: "Pricing", path: "/pricing", icon: <FaTags /> },
    { name: "Reports", path: "/reports", icon: <FaChartLine /> },
    { name: "Audit Log", path: "/audit-log", icon: <FaClipboardList /> },
    { name: "Settings", path: "/settings", icon: <FaCog /> },
    { name: "Support", path: "/support", icon: <FaHeadset /> },
  ];

  return (
    <div className="sidebar">

      {/* Logo Section */}
      <div className="sidebar-header">
        {/* <img src={logo} alt="Logo" className="sidebar-logo" /> */}
        <h1 className="sidebar-title">Fliplyn</h1>
      </div>

      <ul className="sidebar-menu">
        {menus.map((menu, index) => (
          <li key={index}>
            <NavLink
              to={menu.path}
              className={({ isActive }) =>
                isActive ? "sidebar-link active" : "sidebar-link"
              }
            >
              <span className="icon">{menu.icon}</span>
              <span className="text">{menu.name}</span>
            </NavLink>
          </li>
        ))}
      </ul>

    </div>
  );
}
